/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LoginAccountInSysOrgDto } from '../models/LoginAccountInSysOrgDto';
import type { SysOrgRoleName } from '../models/SysOrgRoleName';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LoginAccountService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns LoginAccountInSysOrgDto OK
     * @throws ApiError
     */
    public createLoginAccount(
        requestBody?: LoginAccountInSysOrgDto,
    ): CancelablePromise<LoginAccountInSysOrgDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/LoginAccount/CreateLoginAccount',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all LoginAccounts in a SysOrg for a specific role. Only SuperAdmin or users with any role in the SysOrg can access this endpoint.
     * When roleName is Compliance.General.Services.SysOrgRoleName.Guest, the result can also include accounts that do not yet have an explicit role in the SysOrg when they are in the User Entra flow and their `DefaultSysOrgGuid` matches sysOrgGuid; those returned DTOs are surfaced as Guest.
     * @param sysOrgGuid The unique identifier of the SysOrg whose login accounts are being requested.
     * @param roleName The role filter to apply. When this is Compliance.General.Services.SysOrgRoleName.Guest, the endpoint also includes qualifying no-role User Entra accounts whose `DefaultSysOrgGuid` matches sysOrgGuid, and returns them as Guest.
     * @returns LoginAccountInSysOrgDto OK
     * @throws ApiError
     */
    public getLoginAccounts(
        sysOrgGuid: string,
        roleName: SysOrgRoleName,
    ): CancelablePromise<Array<LoginAccountInSysOrgDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/LoginAccount/{sysOrgGuid}/{roleName}/GetLoginAccounts',
            path: {
                'sysOrgGuid': sysOrgGuid,
                'roleName': roleName,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
